import {
  ConfirmPaymentRequestBody,
  ConfirmPaymentResponse,
  InitiatePaymentRequestBody,
  InitiatePaymentResponse,
  WalletsPaymentsClient,
} from "@nestcoinco/hyper-api-gateway-api-client";

import apiConfig from "../config/api-config";
import { axiosInstance } from "../config/axios-instance";

const walletPaymentsClient = new WalletsPaymentsClient(
  apiConfig,
  undefined,
  axiosInstance
);

const handleInitiatePayment = async (
  requestBody: InitiatePaymentRequestBody
): Promise<InitiatePaymentResponse | undefined> => {
  try {
    const initiatePaymentData = (
      await walletPaymentsClient.initiatePayment(requestBody)
    ).data;
    return initiatePaymentData;
  } catch {
    return;
  }
};

const handleConfirmPayment = async (
  provider: string,
  requestBody: ConfirmPaymentRequestBody
): Promise<ConfirmPaymentResponse | undefined> => {
  try {
    const confirmPaymentData = (
      await walletPaymentsClient.confirmPayment(provider, requestBody)
    ).data;
    return confirmPaymentData;
  } catch {
    return;
  }
};

export { handleInitiatePayment, handleConfirmPayment };
